import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=73cf0e81&scoped=true"
import script from "./contracts.vue?vue&type=script&lang=js"
export * from "./contracts.vue?vue&type=script&lang=js"
import style0 from "./contracts.vue?vue&type=style&index=0&id=73cf0e81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cf0e81",
  null
  
)

export default component.exports